// Date-only values ("2026-11-02") must never go through `new Date()` + toLocaleDateString —
// they parse as UTC midnight and show up a day early west of Greenwich.
export const fmtDate = (d) => {
  if (!d) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(d).slice(0, 10));
  if (m && !String(d).includes("T")) {
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString();
  }
  return new Date(d).toLocaleDateString();
};
